import React, { useCallback } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { forgotPassword } from 'actions/AuthActions'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import TextLink from 'LuxKit/TextLink'
import BusinessTravellerLoginBack from 'businessTraveller/components/business-account/BusinessTravellerLoginBack'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import noop from 'lib/function/noop'
import { AccountAccessSurface } from './AccountAccessModalWrapper'

export const FORGOT_PASSWORD_TITLE = 'A reset link has been sent to your email'

interface Props {
  user: App.User;
  onModeChange?: (nextMode: App.UiAccountModalMode) => void;
  variant?: AccountAccessSurface;
}

function AccountAccessForgetPassword(props: Props) {
  const {
    user,
    onModeChange = noop,
    variant = 'modal',
  } = props

  const isPage = variant === 'page'

  const dispatch = useAppDispatch()

  const onForgotPassword = useCallback(() => {
    dispatch(forgotPassword(user.email!))
  }, [dispatch, user])

  const onBack = useCallback(() => onModeChange('login'), [onModeChange])

  return (
    <>
      {/* Back button on login page */}
      {isPage && <BusinessTravellerLoginBack onBack={onBack} />}

      {/* Forgot password content */}
      <VerticalSpacer gap={24}>
        {isPage && <Heading variant="heading2">{FORGOT_PASSWORD_TITLE}</Heading>}

        <BodyText variant="large" weight="bold">{user.email}</BodyText>
        <BodyText variant="medium">
          The reset link will expire in 24 hours. Please remember to check your spam folder.
        </BodyText>
        <BodyText variant="medium" colour="neutral-two">
          Don't see the email?{' '}<TextLink onClick={onForgotPassword}>Resend the email</TextLink>.
        </BodyText>
      </VerticalSpacer>
    </>
  )
}

export default AccountAccessForgetPassword
